export const EMAIL_SUB_LABEL = "This won't be shown on your profile.";
export const USERNAME_SUB_LABEL =
  "Minimum 4 characters. Periods and underscores are allowed.";
